export interface ErkomFormValue {
  patientId: number | null;
  tutorName?: string | null;
  tutor_name?: string | null;
  implantMaterial: string;
  cryoanalgesia: boolean;
  implantTestDate: string | null;
  surgeryDate: string | null;
  surgeryLocation: string | number | null;
  fakeSurgeryCompleted?: boolean;
  procedure_id: number | null,
  number_implants: number | null,
  observations: string;
  zip_path?: string;
}


